module.exports = __webpack_public_path__ + "static/media/icon_social-google.e6ddc985.svg";